import acba from '../../assets/partnersLogo/acba.png';
import aeb from '../../assets/partnersLogo/aeb.png';
import ameria from '../../assets/partnersLogo/ameria.png';
import amio from '../../assets/partnersLogo/amio.png';
import araratbank from '../../assets/partnersLogo/ararat.png';
import ardshinbank from '../../assets/partnersLogo/Ardshinbank.png';
import armswiss from '../../assets/partnersLogo/Armswiss.png';
import artsakhBank from '../../assets/partnersLogo/artsakh-bank.png';
import convers from '../../assets/partnersLogo/convers.png';
import crossNet from '../../assets/partnersLogo/crossam.jpg';
import evoca from '../../assets/partnersLogo/evoca.png';
import fastbank from '../../assets/partnersLogo/fastbank.png';
import idBank from '../../assets/partnersLogo/id-bank.png';
import ineco from '../../assets/partnersLogo/ineco.png';
import infosec from '../../assets/partnersLogo/infosec.png';
import smartSoft from '../../assets/partnersLogo/smartSoft.png';
import unibank from '../../assets/partnersLogo/unibank.jpg';
import vtb from '../../assets/partnersLogo/vtb.png';
interface PartnersInfoType {
	logo: string;
	name: string;
	link: string;
}
export const partnersInfo: PartnersInfoType[] = [
	{logo: acba, name: 'ACBA BANK', link: 'https://www.acba.am/'},
	{logo: aeb, name: 'AEB BANK', link: 'https://www.aeb.am/'},
	{logo: ameria, name: 'AMERIA BANK', link: 'https://ameriabank.am/'},
	{logo: amio, name: 'AMIO BANK', link: 'https://www.amiobank.am'},
	{logo: araratbank, name: 'ARARAT BANK', link: 'https://www.araratbank.am/'},
	{logo: ardshinbank, name: 'ARDSHINBANK', link: 'https://www.ardshinbank.am/'},
	{logo: armswiss, name: 'ARMSWISS BANK', link: 'https://www.armswissbank.am/'},
	{logo: artsakhBank, name: 'ARTSAKH BANK', link: 'https://www.artsakhbank.am/'},
	{logo: convers, name: 'CONVERSE BANK', link: 'https://www.conversebank.am/'},
	{logo: crossNet, name: 'CROSS NET', link: 'https://www.cross.am/'},
	{logo: evoca, name: 'EVOCABANK', link: 'https://www.evocabank.am/'},
	{logo: fastbank, name: 'FASTBANK', link: 'https://www.fastbank.am/'},
	{logo: idBank, name: 'ID BANK', link: 'https://www.idbank.am/'},
	{logo: ineco, name: 'INECO BANK', link: 'https://www.inecobank.am/'},
	{logo: infosec, name: 'INFOSEC', link: 'https://www.infosec.am/'},
	{logo: smartSoft, name: 'SMARTSOFT', link: 'https://www.smartsoft.am/'},
	{logo: unibank, name: 'UNIBANK', link: 'https://www.unibank.am/'},
	{logo: vtb, name: 'VTB BANK', link: 'https://www.vtb.am/'}
];
